import type { AuditEntry } from '@peles/shared';
import { apiClient } from './client';

export async function getEntityAudit(entityType: string, entityId: string): Promise<AuditEntry[]> {
  const { data } = await apiClient.get<AuditEntry[]>(`/audit/${entityType}/${entityId}`);
  return data;
}
